import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`py-24 ${className}`} data-id="element-234">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-235">
        {children}
      </motion.div>
    </section>;
}